<template>
  <div>
    <div v-if="editable" class="address">
      <div class="delete-address">
        <font-awesome-icon icon="times" class="address-close" @click="deleteAddressEntry()" />
      </div>
      <InputField
        :readonly="isFieldReadOnly"
        menu-label="Address Line1"
        :value="address.line1"
        name="line1"
        type="text"
        class="form-input"
        @change="onChange"
      />

      <InputField
        :readonly="isFieldReadOnly"
        menu-label="line2"
        :value="address.line2"
        name="line2"
        type="text"
        class="form-input"
        @change="onChange"
      />

      <div class="city-province-container">
        <InputField
          :readonly="isFieldReadOnly"
          menu-label="City"
          :value="address.city"
          name="city"
          type="text"
          class="form-input"
          @change="onChange"
        />
        <DropdownSelect
          menu-label="Select Province"
          :disabled="isFieldReadOnly"
          :menu-items="provinceAbbrs"
          :selected-item="address.province_abbr"
          name="province_abbr"
          class="bordered"
          @select-item="onProvinceChange"
        />
      </div>
      <div>
        <InputField
          :readonly="isFieldReadOnly"
          menu-label="Postal Code"
          :value="address.postal_code"
          name="postal_code"
          type="text"
          class="form-input"
          @change="onChange"
        />
      </div>
      <div>
        <Checkbox
          size="tiny"
          :checked="address.id === defaultId"
          :class="checkboxStyle"
          @change="onSelect"
        />
        <label>Default Address</label>
      </div>
    </div>
    <div v-else>
      <div>{{ address.line1 }},</div>
      <div>{{ address.line2 }}</div>
      <div>{{ address.city }},{{ address.province_abbr }}</div>
      <div>{{ address.postal_code }}</div>
    </div>
  </div>
</template>
<script>
import InputField from '@/app/components/InputField';
import Checkbox from '@/app/components/Checkbox';
import DropdownSelect from '@/app/components/DropdownSelect';
import { AppGetters } from '@/app/app.keys';
export default {
  name: 'TolAddress',
  components: {
    InputField,
    DropdownSelect,
    Checkbox
  },
  props: {
    address: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    defaultId: {
      type: [Number, String],
      default: ''
    },
    isFieldReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOnScreenDataModified: false,
      defaultClientAddress: false
    };
  },
  computed: {
    provinceAbbrs() {
      return this.$store.getters[AppGetters.ProvinceAbbreviations];
    },
    checkboxStyle() {
      if (this.isFieldReadOnly) {
        return 'address-readonly';
      }
      return '';
    }
  },
  methods: {
    onChange(event) {
      this.$emit('change', {
        name: event.target.name,
        value: event.target.value,
        updateAddress: this.address
      });
    },
    onProvinceChange(event) {
      this.$emit('change', {
        name: 'province_abbr',
        value: event,
        updateAddress: this.address
      });
    },
    deleteAddressEntry() {
      this.$emit('delete', this.address);
    },
    onSelect() {
      this.$emit('change', {
        name: 'is_default',
        value: this.address.id,
        updateAddress: this.address
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/app/styles/colors.scss';
.address {
  margin-bottom: 20px;
  border: 1px solid $light-grey-1;
  padding: 10px;
  flex-basis: 25%;
}
.delete-address {
  display: flex;
  justify-content: flex-end;
}
.form-input {
  border-bottom: 1px solid $blue;
  font-size: 1em;
  height: inherit;
}
.address-close {
  color: $red;
  cursor: pointer;
}
.city-province-container {
  div {
    margin-bottom: 4px;
  }
}
</style>
